<template>
  <div class="app-site">
    <div class="site-title">
      <div class="app-title" @click="skipSite">場地租借管理系統</div>
      <div class="admin-btn" v-if="isEmployee">
        <tw-btn title="前往管理後台" @click="goToAdmin"></tw-btn>
      </div>
    </div>
    <div class="calendar-content">
      <div class="activity-top">
        <div class="activity-left">
          <form class="activity-from">
            <div class="activity-from-item">
              <label class="from-label">申請使用場地</label>
              <div class="from-content from-item1">
                <div v-for="(item,i) in siteArr" :key="item.ID" class="radio-item">
                  <span>
                    <span
                      class="round"
                      :class="{'select-color' : BookingSiteID == item.ID}"
                      v-show="item.SubSites.length == 0"
                      @click="changeSite(item)"
                    ></span>
                    <span class="title">{{item.MainSite}}</span>
                    <span class="interval" v-show="i != 0">(</span>
                  </span>
                  <span v-for="ele in item.SubSites" :key="ele.ID">
                    <span
                      class="round"
                      :class="{ 'select-color' : BookingSiteID == ele.ID }"
                      @click="changeSite( ele )"
                    ></span>
                    <span class="title">{{ele.SubSite}}</span>
                  </span>
                  <span class="interval" v-show="i != 0">)</span>
                </div>
              </div>
            </div>
            <div class="activity-from-item from-input1">
              <label class="from-label">舉辦活動名稱</label>
              <div class="from-content">
                <input type="text" placeholder="請輸入活動名稱" v-model="ActivityTitle" />
              </div>
            </div>
            <div class="activity-from-item from-activity">
              <label class="from-label">舉辦活動性質</label>
              <ul class="from-content">
                <li v-for="item in activityArr" :key="item.ID">
                  <span
                    class="round"
                    :class="{'select-color' : ActivityTypeID == item.ID }"
                    @click="activityClick(item)"
                  ></span>
                  <span class="title">{{item.TypeName}}</span>
                </li>
              </ul>
            </div>
            <div class="activity-from-item from-input1">
              <label class="from-label">舉辦活動內容</label>
              <div class="from-content">
                <input type="text" placeholder="請輸入活動內容" v-model="ActivityContent" />
              </div>
            </div>
            <div class="activity-from-item" v-for="item in dateArr" :key="item.order">
              <label class="from-label">{{item.title}}</label>
              <div class="from-content from-date-time">
                <div class="select-date">
                  <span>{{item.date | filterDate}}</span>
                  <span class="iconfont icon-bArrow"></span>
                  <el-date-picker
                    v-model="item.date"
                    :editable="false"
                    type="date"
                    placeholder="選擇日期"
                    class="change-date"
                    @change="DatePickerChangeHandler($event, item)"
                  ></el-date-picker>
                </div>
                <div class="select-time">
                  <span>{{item.time | filterTime}}</span>
                  <span class="iconfont icon-bArrow"></span>
                  <el-time-select
                    placeholder="起始時間"
                    v-model="item.time"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '23:59'
                    }"
                    class="change-time"
                  ></el-time-select>
                </div>
              </div>
            </div>
            <div
              class="activity-from-item from-input"
              v-for="(item, index) in inputArr"
              :key="index"
            >
              <label class="from-label" v-if="item.verify !== 'bank' & isEmployee">{{item.title}}</label>
              <label class="from-label" v-else-if="item.verify === 'bank' & isEmployee"></label>
              <label class="from-label" v-else>{{item.title}}</label>

              <div class="from-content">
                <input
                  v-if="item.verify == 'number'"
                  type="text"
                  v-model="item.value"
                  @input="numberInput(item)"
                  @change="numberInput(item)"
                  :placeholder=" '請輸入'+ item.title"
                  :maxlength="item.maxLength"
                />
                <input
                  v-else-if="item.verify == 'email'"
                  type="text"
                  v-model="item.value"
                  :placeholder=" '請輸入'+ item.title"
                  :maxlength="item.maxLength"
                />
                <input
                  v-else-if="item.verify === 'string'"
                  type="text"
                  v-model="item.value"
                  :placeholder=" '請輸入'+ item.title"
                  :maxlength="item.maxLength"
                />
                <input
                  v-else-if="item.verify === 'bank' & !isEmployee"
                  type="text"
                  v-model="item.value"
                  :placeholder=" '請輸入'+ item.title"
                  :maxlength="item.maxLength"
                />
              </div>
            </div>
            <div class="note" v-if="!isEmployee">
              <span>註：申請場地之機關法人團體帳戶</span>
            </div>
            <!-- <div class="activity-from-item">
              <label class="from-label">申請日期</label>
              <div class="from-content">
                <span class="now-day">107年12月30日</span>
              </div>
            </div>-->
          </form>
        </div>
        <div class="activity-right">
          <div class="note">
            <span class="title">備註</span>
            <div class="note-content">
              <textarea v-model="Remark" :maxlength="200"></textarea>
            </div>
          </div>
          <div class="img-data">
            <div class="operation-area">
              <span class="headline">附件</span>
              <div class="area" @click="upLoadImg">
                <span class="iconfont icon-upload"></span>
                <span>請拖拽檔案至此區塊</span>
                <input
                  @change="inputChange"
                  ref="upLoadImg"
                  type="file"
                  name="file"
                  multiple="multiple"
                />
              </div>
            </div>
            <div class="img-progress" v-for="(item, index) in fileData" :key="index">
              <div class="look-img">
                <img :src="item.content" alt />
              </div>
              <div class="look-progress">
                <div class="img-name">
                  <span class="name">{{item.name}}</span>
                  <!-- <span
                    class="iconfont icon-guanbi"
                    v-show="item.complete != '100%'"
                    @click="deleteImg(i)"
                  ></span>-->
                </div>
                <div class="file-size">{{item.size}}</div>
                <div class="grogress">
                  <span
                    class="grogress-success"
                    :style="{ width: item.complete,transition: 'linear .3s' }"
                  ></span>
                </div>
                <div class="proportion">
                  <span>{{item.complete}}</span>
                  <span v-show="item.errorIsShow">檔案傳送失敗</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="activity-link">
          <div class="table" style="width: 6rem;" @click="downloadClick">
            <span class="iconfont icon-download"></span>
            <br />
            <span class="title">申請書下載</span>
          </div>
          <!-- <div class="light">
                        <span class="iconfont icon-light"></span>
                        <span class="title">灯光租借</span>
          </div>-->
        </div>
      </div>
      <div class="activity-foot">
        <div class="btn-box">
          <tw-btn :title="isFromBackstage ? '修改' : '申請'" @click="confirm"></tw-btn>
          <tw-btn class="calcel" title="取消" @click="cancel"></tw-btn>
        </div>
      </div>
    </div>

    <verifySMS v-if="showSmsModal">
      <div slot="header">請輸入簡訊驗證碼</div>
      <div slot="body" class="sms-body">
        <input type="text" v-model="inputVerifyCode" />
        <button @click="SmsResend">
          <span v-if="smsTimerCount > 0">{{smsTimerCount}}</span>
          <img
            :class="{reciprocal: smsTimerCount > 0}"
            src="../assets/cycle-loading.png"
            width="100%"
            height="100%"
          />
        </button>
      </div>
      <div slot="footer" class="modal-footer">
        <div class="button">
          <tw-btn title="送出" @click="VerifySms"></tw-btn>
        </div>
        <div class="button">
          <tw-btn title="取消" @click="showSmsModal = false;inputVerifyCode = null;"></tw-btn>
        </div>
      </div>
    </verifySMS>
  </div>
</template>

<script>
import API from "../api/index.js";
import TwBtn from "../components/tw-btn";
import verifySMS from "../components/lease/VerifySMS";
const smsResendSec = 300;

export default {
  data() {
    return {
      BookingID: null,
      BookingSiteID: null, // Application venue
      ActivityTypeID: null, // Activity type
      ActivityTitle: null, // Activity name
      ActivityContent: null, // Activity content
      dateArr: [],
      inputArr: [],
      siteArr: [],
      activityArr: [],
      Remark: "", // Remarks
      nowTime: "",
      // Upload attachments
      fileData: [],
      isRouteLease: false,

      // nicky
      showSmsModal: false,
      smsTimerCount: smsResendSec,
      verifyCode: null,
      inputVerifyCode: null
    };
  },
  components: {
    TwBtn,
    verifySMS
  },

  created() {
    const nowDate = new Date();
    let year = nowDate.getFullYear() - 1911;
    let month = nowDate.getMonth();
    let date = nowDate.getDate();
    this.nowTime = `${year}年${month}月${date}日`;
    if (
      this.$store.state.storageSelectData != null &&
      this.$store.state.storageSelectData.length != 0
    ) {
      this.updateData();
    } else {
      let id = this.getUrlKey("id");
      if (id != undefined) {
        this.$axios
          .get(API.addAndGetLendingSite + "/" + id)
          .then(res => {
            let updateData = res.data;
            this.updateData(updateData[0]);
          })
          .catch(err => {
            this.initData();
          });
      } else {
        this.initData();
      }
    }
    this.getSite();
    this.getActivityType();
    if (this.BookingID != null) {
      this.isRouteLease = true;
    }
  },

  mounted() {
    const dropbox = document.querySelector(".area");
    dropbox.addEventListener("dragenter", this.onDrag, false);
    dropbox.addEventListener("dragover", this.onDrag, false);
    dropbox.addEventListener("drop", this.onDrop, false);
  },

  methods: {
    skipSite() {
      if (
        this.$store.state.query.System == null &&
        this.$store.state.query.Ticket == null
      ) {
        this.$router.push({ path: "/site" });
      } else {
        this.$router.push({
          path: "/site",
          query: {
            System: this.$store.state.query.System,
            Ticket: this.$store.state.query.Ticket
          }
        });
      }
    },
    goToAdmin() {
      this.$router.push({
        path: "/lease-login",
        query: {
          System: this.$store.state.query.System,
          Ticket: this.$store.state.query.Ticket
        }
      });
    },
    // Submit
    confirm() {
      let isSuccess = this.judgeData();
      if (isSuccess !== "isOk") {
        this.$alert(
          this.$createElement("pre", isSuccess.join("\r\n")),
          "提示",
          {
            confirmButtonText: "確定",
            callback: action => {}
          }
        );
        return;
      }

      // General public
      if (this.isEmployee === false) {
        if (this.fileData.length === 0) {
          this.$alert("請選擇申請書附件", "提示");
          return;
        }

        // Countdown to send SMS
        this.$axios
          .get(API.smsVerify + this.inputArr[5].value)
          .then(res => {
            let data = res.data;
            this.verifyCode = data.Code;

            if (this.smsTimerCount <= 0 || this.smsTimerCount >= smsResendSec) {
              this.smsTimerCount = smsResendSec;
              this.SmsTimerLoop();
            }
            this.showSmsModal = !this.showSmsModal;
            return;
          })
          .catch(err => {
            this.$alert("請填寫正確的手機號碼(09開頭)", "提示", {
              confirmButtonText: "確定",
              callback: action => {}
            });
            return;
          });
      }
      // City government employee
      else {
        this.$axios
          .get(API.getProfile)
          .then(res => {
            //console.log(res);
            // If no lending ID, add new; otherwise modify
            // Check if this is a modification
            if (this.isFromBackstage === false) {
              this.ajaxAddsite();
            } else {
              this.editorLendingSiteData();
            }
            return;
          })
          // Ticket verification failed
          .catch(err => {
            if (err.response.status === 400) {
              this.$alert("驗證失敗，請重新登入愛上網", "提示", {
                confirmButtonText: "確定",
                callback: action => {}
              });
              this.$router.push({ path: "/href" });
            }
          });
      }
    },
    // Cancel
    cancel() {
      // this.$router.go(-1);

      if (this.isFromBackstage) {
        this.$router.push({
          path: "/lease",
          query: {
            System: this.$store.state.query.System,
            Ticket: this.$store.state.query.Ticket,
            page: this.$route.query.page
          }
        });
      } else {
        this.$router.push({
          path: "/site"
        });
      }

      // if (this.isRouteLease) {
      //   // this.$router.push({path:'/lease'})
      //   this.$router.push({
      //     path: "/lease",
      //     query: {
      //       System: this.$store.state.query.System,
      //       Ticket: this.$store.state.query.Ticket
      //     }
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/site"
      //     // query: {
      //     //   System: this.$store.state.query.System,
      //     //   Ticket: this.$store.state.query.Ticket
      //     // }
      //   });
      //   // this.initData();
      // }
    },
    // Venue selection
    changeSite(_item) {
      this.BookingSiteID = _item.ID;
    },
    // Activity type selection
    activityClick(_item) {
      this.ActivityTypeID = _item.ID;
    },
    // Click to download attachment
    downloadClick() {
      if (this.BookingSiteID === undefined || this.BookingSiteID === null)
        return;

      let src = "download/site_attached/" + this.BookingSiteID;
      var eleLink = document.createElement("a");
      eleLink.download = src;
      eleLink.style.display = "none";
      eleLink.href = src;
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
    },
    //
    numberInput(_item) {
      _item.value = _item.value.replace(/[^\d|^#]/g, "");
    },
    // Initialize page data
    initData() {
      let date = new Date();
      date.setDate(date.getDate() + 1);
      this.BookingID = null;
      this.BookingSiteID = null; // Application venue
      this.ActivityTypeID = null; // Activity type
      this.ActivityTitle = null; // Activity name
      this.ActivityContent = null; // Activity content
      (this.inputArr = [
        {
          order: 1,
          title: "申請單位",
          maxLength: 30,
          value: "",
          // judgeEmpty: true,
          verify: "string"
        },
        {
          order: 2,
          title: "聯絡人",
          maxLength: 50,
          value: "",
          // judgeEmpty: true,
          verify: "string"
        },
        {
          order: 3,
          title: "聯絡地址",
          maxLength: 50,
          value: "",
          // judgeEmpty: true,
          verify: "string"
        },
        {
          order: 4,
          title: "連絡電話",
          maxLength: 20,
          value: "",
          // judgeEmpty: true,
          verify: "number"
        },
        {
          order: 5,
          title: "E-mail",
          maxLength: 300,
          value: "",
          // judgeEmpty: true,
          verify: "email"
        },
        {
          order: 6,
          title: "手機",
          maxLength: 20,
          value: "",
          // judgeEmpty: true,
          verify: "number"
        },
        {
          order: 8,
          title: "銀行代碼",
          maxLength: 5,
          value: "",
          // judgeEmpty: false,
          verify: "bank"
        },
        {
          order: 9,
          title: "銀行帳號",
          maxLength: 50,
          value: "",
          // judgeEmpty: false,
          verify: "bank"
        }
      ]),
        (this.dateArr = [
          { order: 11, title: "起始時間(場佈)", date: date, time: "00:00" },
          { order: 12, title: "終止時間(撤場)", date: date, time: "00:00" },
          { order: 13, title: "正式活動時間", date: date, time: "00:00" },
          { order: 14, title: "活動結束時間", date: date, time: "00:00" }
        ]);
    },
    updateData(updateData) {
      this.BookingID = updateData.ID;
      this.BookingSiteID = updateData.LendingSiteID; // Application venue
      this.ActivityTypeID = updateData.ActivityTypeID; // Activity type
      this.ActivityTitle = updateData.ActivityTitle; // Activity name
      this.ActivityContent = updateData.ActivityContent; // Activity content
      let LendingContact = updateData.LendingContact;
      this.inputArr = [
        {
          order: 1,
          title: "申請單位",
          maxLength: 30,
          value: LendingContact.Dept,
          // judgeEmpty: !!LendingContact.Dept,
          verify: "string"
        },
        {
          order: 2,
          title: "聯絡人",
          maxLength: 50,
          value: LendingContact.Name,
          Name: !!LendingContact.Name,
          verify: "string"
        },
        {
          order: 3,
          title: "聯絡地址",
          maxLength: 50,
          value: LendingContact.Address,
          // judgeEmpty: !!LendingContact.Address,
          verify: "string"
        },
        {
          order: 4,
          title: "連絡電話",
          maxLength: 20,
          value: LendingContact.Phone,
          // judgeEmpty: !!LendingContact.Phone,
          verify: "number"
        },
        {
          order: 5,
          title: "E-mail",
          maxLength: 300,
          value: LendingContact.Email,
          // judgeEmpty: !!LendingContact.Email,
          verify: "email"
        },
        {
          order: 6,
          title: "手機",
          maxLength: 20,
          value: LendingContact.CellPhone,
          // judgeEmpty: !!LendingContact.CellPhone,
          verify: "number"
        },
        {
          order: 8,
          title: "銀行代碼",
          maxLength: 5,
          value: LendingContact.BankCode,
          // judgeEmpty: !!LendingContact.BankCode,
          verify: "bank"
        },
        {
          order: 9,
          title: "銀行帳戶",
          maxLength: 50,
          value: LendingContact.BankAccount,
          // judgeEmpty: !!LendingContact.BankAccount,
          verify: "bank"
        }
      ];
      let BeginTime = this.judgeTime(updateData.BeginTime);
      let AcBeginTime = this.judgeTime(updateData.AcBeginTime);
      let AcEndTime = this.judgeTime(updateData.AcEndTime);
      let EndTime = this.judgeTime(updateData.EndTime);
      this.dateArr = [
        {
          order: 11,
          title: "起始時間(場佈)",
          date: updateData.BeginTime,
          time: BeginTime
        },
        {
          order: 12,
          title: "結束時間(撤場)",
          date: updateData.EndTime,
          time: EndTime
        },
        {
          order: 13,
          title: "正式活動時間",
          date: updateData.AcBeginTime,
          time: AcBeginTime
        },
        {
          order: 14,
          title: "活動結束時間",
          date: updateData.AcEndTime,
          time: AcEndTime
        }
      ];
      this.Remark = updateData.Remark;
    },
    judgeTime(val) {
      let time = val.split("T")[1].split(":");
      return `${time[0]}:${time[1]}`;
    },
    // Add lending order
    ajaxAddsite() {
      let toBooking = this.isEmployee ? 1 : 0;
      let data = this.getAjaxData(toBooking);
      data.BookingID = this.BookingID;

      this.$axios
        .post(API.addAndGetLendingSite, data)
        .then(res => {
          this.BookingID = res.data.ID;
          // upload attached
          this.fileData.forEach((el, index) => {
            if (el.complete !== "100%") this.uploadFile(el.data, index);
          });

          let deadline = this.siteArr.some(
            s => s.ID === this.BookingSiteID && s.SubSites.length === 0
          )
            ? 10
            : 20;
          let message = `預約成功，請於活動${deadline}日以前以e-mail提送場地申請書`;

          this.$alert(message, "新增成功！", {
            confirmButtonText: "確定",
            callback: action => {
              let system = this.$store.state.query.System;
              let ticket = this.$store.state.query.Ticket;

              if (system === null || ticket === null) {
                this.$router.push({
                  path: "/site"
                });
              } else {
                this.$router.push({
                  path: "/site",
                  query: {
                    System: system,
                    Ticket: ticket
                  }
                });
              }
            }
          });
        })
        .catch(err => {
          var data = err.response.data;
          this.$alert(data.Message, "提示", {
            confirmButtonText: "確定",
            callback: action => {}
          });
        });
    },
    // Update lending order data
    editorLendingSiteData() {
      let toBooking = this.isEmployee ? 1 : 0; // Not needed for update
      let data = this.getAjaxData(toBooking);
      this.$axios
        .patch(API.addAndGetLendingSite + "/" + this.BookingID, data)
        .then(res => {
          // upload attached
          this.fileData.forEach((el, index) => {
            if (el.complete !== "100%") this.uploadFile(el.data, index);
          });

          this.$alert("更新成功", "提示", {
            confirmButtonText: "確定",
            callback: action => {}
          });
        })
        .catch(err => {
          this.$alert("更新失敗，請重試", "提示", {
            confirmButtonText: "確定",
            callback: action => {}
          });
        });
    },
    // Validate form data
    judgeData() {
      let errorMessage = [];
      let today = new Date();
      if (
        this.isFromBackstage === false &&
        this.dateArr.some(d => d.date <= today)
      )
        errorMessage.push("不可選擇過去的日期");

      let beginDate = this.$moment(this.dateArr[0].date);
      let beginTime = this.$moment(this.dateArr[0].time, "HH:mm");
      beginDate.set({
        hour: beginTime.get("hour"),
        minute: beginTime.get("minute")
      });

      let endDate = this.$moment(this.dateArr[1].date);
      let endTime = this.$moment(this.dateArr[1].time, "HH:mm");
      endDate.set({
        hour: endTime.get("hour"),
        minute: endTime.get("minute")
      });

      let acBeginDate = this.$moment(this.dateArr[2].date);
      let acBeginTime = this.$moment(this.dateArr[2].time, "HH:mm");
      acBeginDate.set({
        hour: acBeginTime.get("hour"),
        minute: acBeginTime.get("minute")
      });

      let acEndDate = this.$moment(this.dateArr[3].date);
      let acEndTime = this.$moment(this.dateArr[3].time, "HH:mm");
      acEndDate.set({
        hour: acEndTime.get("hour"),
        minute: acEndTime.get("minute")
      });

      if (endDate <= beginDate) errorMessage.push("終止時間不得小於起始時間");
      if (acBeginDate >= acEndDate)
        errorMessage.push("活動結束時間不得小於正式活動時間");
      if (acBeginDate < beginDate || acEndDate > endDate)
        errorMessage.push("正式活動時間/活動結束時間需包含起始時間/終止時間");

      if (this.BookingSiteID == "" || this.BookingSiteID == null)
        errorMessage.push("請選擇使用場地");
      if (this.ActivityTitle == "" || this.ActivityTitle == null)
        errorMessage.push("請輸入活動名稱");
      if (this.ActivityTypeID == "" || this.ActivityTypeID == null)
        errorMessage.push("請選擇活動性質");
      if (this.ActivityContent == "" || this.ActivityContent == null)
        errorMessage.push("請輸入活動內容");
      let arr = [
        "請輸入申請單位",
        "請輸入聯絡人",
        "請輸入聯絡地址",
        "請輸入連絡電話",
        "請輸入E-mail",
        "請輸入手機號碼",
        "請輸入銀行代碼",
        "請輸入銀行帳戶",
        "請輸入正確的E-mail格式"
      ];
      for (let i = 0; i < this.inputArr.length; i++) {
        if (this.inputArr[i].verify === "bank") {
          if (this.isEmployee === true) {
            continue;
          } else {
            if (!!this.inputArr[i].value === false) {
              errorMessage.push(arr[i]);
              continue;
            }
          }
        } else if (this.inputArr[i].verify == "email") {
          if (!this.verifyEmail(this.inputArr[i].value)) {
            errorMessage.push(arr[arr.length - 1]);
          }
        } else if (!!this.inputArr[i].value === false) {
          errorMessage.push(arr[i]);
          continue;
        }
      }

      if (errorMessage.length === 0) return "isOk";
      else return errorMessage;
    },
    // Email address validation
    verifyEmail(_value) {
      // console.log(_value)
      let mal = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!mal.test(_value)) {
        return false;
      } else {
        return true;
      }
    },
    // Get data required for backend
    getAjaxData(toBooking) {
      let arr = JSON.parse(JSON.stringify(this.dateArr));
      arr.forEach(item => {
        let date = new Date(item.date);
        let time = item.time.split(":");
        let y = date.getFullYear(),
          m = date.getMonth(),
          d = date.getDate(),
          h = time[0],
          i = time[1],
          s = "00";
        let dd = `${y}-${m + 1}-${d}T${h}:${i}:${s}`;
        item.date = dd;
      });
      let data = {
        LendingSiteID: this.BookingSiteID, // Application venue
        ActivityTypeID: this.ActivityTypeID, // Activity type
        ActivityTitle: this.ActivityTitle, // Activity name
        ActivityContent: this.ActivityContent, // Activity content
        BeginTime: arr[0].date, // Setup time
        EndTime: arr[1].date, // End time
        AcBeginTime: arr[2].date, // Event start time
        AcEndTime: arr[3].date, // Event end time
        LendingDept: this.inputArr[0].value, // Applicant department
        Contact: {
          Name: this.inputArr[1].value, // Contact person
          Address: this.inputArr[2].value, // Address
          Phone: this.inputArr[3].value, // Phone
          Email: this.inputArr[4].value, // Email
          CellPhone: this.inputArr[5].value, // Mobile phone
          BankCode: this.inputArr[6].value, // Bank code
          BankAccount: this.inputArr[7].value // Bank account
        },
        Remark: this.Remark, // Remarks
        ToBooking: toBooking // Not needed for modify API
      };
      return data;
    },
    getSite() {
      this.$axios.get(API.getSite).then(res => {
        // console.log(res, "Venue");
        this.siteArr = res.data;
      });
    },
    getActivityType() {
      this.$axios.get(API.getActivityType).then(res => {
        // console.log(res, "Category");
        this.activityArr = res.data;
      });
    },
    // Upload attachment ------
    upLoadImg() {
      this.$refs.upLoadImg.click();
    },
    inputChange(e) {
      let files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        // let typeArr = files[i].type.split('/')
        // if( typeArr[0] == 'image' && this.screenImg( typeArr[1] ) ) {
        // console.log(files[i]);

        this.previewImg(files[i]);
        // }else {
        //     this.openInfo('Only jpg, jpeg, png, gif image files are supported')
        // }
      }
    },
    deleteImg(i) {
      this.fileData.splice(i, 1);
    },
    onDrag: function(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    onDrop: function(e) {
      // if (this.BookingID == null) {
      //   this.$alert("Please fill in the form on the left and submit before uploading attachments", "Notice", {
      //     confirmButtonText: "OK",
      //     callback: action => {}
      //   });
      //   // return;
      // } else {
      e.stopPropagation();
      e.preventDefault();
      var dt = e.dataTransfer;
      for (var i = 0; i !== dt.files.length; i++) {
        //let typeArr = dt.files[i].type.split("/");
        // if( typeArr[0] == 'image' && this.screenImg( typeArr[1] ) ) {
        this.previewImg(dt.files[i]);
        // }else {
        //     this.$alert('Please upload images of type jpg, jpeg, png, gif', 'Notice', {
        //         confirmButtonText: 'OK',
        //         callback: action => {}
        //     });
        // }
      }
      // }
    },
    screenImg(_imgType) {
      let arr = ["jpg", "jpeg", "png", "gif"];
      return arr.some(item => {
        return item == _imgType;
      });
    },
    uploadFile(data, _index) {
      var fd = new FormData();
      fd.append("myFile", data);
      let _data = fd;
      var config = {
        async: true,
        contentType: false,
        processData: false,
        // Upload progress tracking
        onUploadProgress: progressEvent => {
          var complete =
            (((progressEvent.loaded / progressEvent.total) * 100) | 0) + "%";
          this.fileData[_index].complete = complete;
        }
      };
      this.$axios
        .post(API.addAndGetLendingSite + "/" + this.BookingID, _data, config)
        .then(res => {})
        .catch(err => {
          this.fileData[_index].errorIsShow = true;
          this.fileData[_index].complete = "0%";
          this.$alert("附件上傳失敗", "提示", {
            confirmButtonText: "確認",
            callback: action => {
              let data = this.fileData;
              let arr = [];
              data.forEach(item => {
                if (!item.errorIsShow) {
                  arr.push(item);
                }
              });
              this.finishDate = arr;
            }
          });
        });
    },
    // Image preview
    previewImg(_fileData) {
      let reader = new FileReader();
      let obj = {
        name: _fileData.name,
        size: Math.floor((_fileData.size / 1024) * 100) / 100 + "KB",
        complete: "0%",
        errorIsShow: false
      };
      reader.readAsDataURL(_fileData);
      reader.onload = e => {
        obj.content = e.target.result;
        obj.data = _fileData;
        this.fileData.push(obj);
        let len = this.fileData.length - 1;
        // console.log(e);

        //this.uploadFile(_fileData, len);
      };
    },
    // Auto fill test data
    falseData() {
      (this.BookingSiteID = 2), // Application venue
        (this.ActivityTypeID = 2), // Activity type
        (this.ActivityTitle = "測試活動名稱1"), // Activity name
        (this.ActivityContent = "測試活動內容"), // Activity content
        (this.inputArr = [
          { title: "申請單位", value: "測試申請單位" },
          { title: "聯絡人", value: "測試聯絡人" },
          { title: "聯絡地址", value: "測試聯絡地址" },
          { title: "連絡電話", value: "測試聯絡電話" },
          { title: "E-mail", value: "123@aa.com" },
          { title: "手機", value: "110120119" },
          { title: "傳真電話", value: "1234566" },
          { title: "銀行帳號", value: "1123468" }
        ]);
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },

    // nicky
    SmsTimerLoop() {
      this.smsTimerCount--;
      this.smsTimerCount > 0 && setTimeout(this.SmsTimerLoop, 1000);
    },
    SmsResend() {
      if (this.smsTimerCount <= 0 || this.smsTimerCount >= smsResendSec) {
        this.smsTimerCount = smsResendSec;
        this.SmsTimerLoop();

        this.$axios
          .get(API.smsVerify + this.inputArr[5].value)
          .then(res => {
            let data = res.data;
            this.verifyCode = data.Code;
            // console.log(this.verifyCode);

            if (this.smsTimerCount <= 0 || this.smsTimerCount >= smsResendSec) {
              this.smsTimerCount = smsResendSec;
              this.SmsTimerLoop();
            }
            return;
          })
          .catch(err => {
            this.$alert("請填寫正確的手機號碼(09開頭)", "提示", {
              confirmButtonText: "確定",
              callback: action => {}
            });
            return;
          });
      }
    },
    VerifySms() {
      if (this.verifyCode === this.inputVerifyCode) {
        this.inputVerifyCode = null;
        this.smsTimerCount = 0;
        this.showSmsModal = false;
        this.ajaxAddsite();

        // this.$alert("OK", "Notice", {
        //   confirmButtonText: "OK",
        //   callback: action => {}
        // });
      } else {
        this.$alert("驗證碼錯誤", "提示", {
          confirmButtonText: "確定",
          callback: action => {}
        });
        return;
      }
    },
    DatePickerChangeHandler(event, item) {
      // Start time (setup)
      if (item.order === 11) {
        for (let i = 1; i < this.dateArr.length; i++) {
          const element = this.dateArr[i];
          element.date = event;
        }
      }
    }
  },

  computed: {
    isFromBackstage() {
      let system = this.$route.query.System;
      let ticket = this.$route.query.Ticket;
      let id = this.$route.query.id;
      return !!system && !!ticket && !!id;
    },
    isEmployee() {
      let systemID = this.$route.query.System;
      let ticket = this.$route.query.Ticket;
      return !!systemID && !!ticket;
    }
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  filters: {
    // Date
    filterDate(value) {
      // console.log( value,'00000000000' )
      const date = new Date(value);
      let dayArr = ["日", "一", "二", "三", "四", "五", "六"];
      let Y = date.getFullYear(),
        m = date.getMonth() + 1,
        d = date.getDate(),
        H = date.getHours(),
        i = date.getMinutes(),
        // s = date.getSeconds(),
        w = date.getDay(); // Note: 0-6 corresponds to Sunday to Saturday
      Y = Y - 1911;
      const t = `${Y}年${m}月${d}日  星期${dayArr[w]}`;
      return t;
    },
    // Time
    filterTime(val) {
      if (val == "") return "";
      let arr = val.split(":");
      let time = "上午",
        h = arr[0];
      if (arr[0] > 12) {
        time = "下午";
        h = h - 12;
        if (h < 10) {
          h = `0${h}`;
        }
      }
      return `${time}  ${h}:${arr[1]}`;
    }
  }
};
</script>

<style lang="less" scoped>
// .app-main {
// }
.app-site {
  width: 100%;
  height: auto;
  .site-title {
    width: 100%;
    height: 7rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .app-title {
      color: #fff;
      font-size: 2.3rem;
      margin-left: 70px;
      cursor: pointer;
    }
    .admin-btn {
      margin-right: 70px;
    }
  }
  .calendar-content {
    width: 100%;
    padding: 4rem 4rem 2rem 4rem;
    border-radius: 3.5rem;
    background: #dfe6e9;
    box-shadow: 0 0.6rem 0 #b7b7b7;
    .activity-top {
      min-height: 53rem;
      .activity-left {
        width: 53rem;
        // height: 59rem;
        float: left;
        // .activity-from {
        // }
        .activity-from-item {
          margin-top: 0.5rem;
        }
        .from-label {
          vertical-align: top;
          width: 12.6rem;
          font-size: 1.2rem;
          display: inline-block;
        }
        .from-content {
          display: inline-block;
          // width: 46rem;
          font-size: 1.1rem;
          .now-day {
            width: 30rem;
            text-align: center;
            line-height: 2.4rem;
            font-size: 1.2rem;
          }
          .radio-item {
            margin-bottom: 0.5rem;
            user-select: none;
          }
          .interval {
            margin-right: 0.2rem;
          }
          .title {
            margin-right: 0.4rem;
            vertical-align: middle;
          }
        }
        .from-activity {
          li {
            display: inline-block;
            margin-right: 0.5rem;
          }
        }
        .from-item1 {
          span {
            display: inline-block;
          }
        }
        .from-date-time {
          .select-date,
          .select-time {
            display: inline-block;
            position: relative;
            background: #fff;
            border-radius: 0.5rem;
            line-height: 2.4rem;
            text-align: center;
            font-size: 1.2rem;
          }
          .select-date {
            width: 18.8rem;
            height: 2.4rem;
          }
          .select-time {
            width: 10.2rem;
            height: 2.4rem;
            margin-left: 0.4rem;
          }
        }
        .from-input {
          input {
            width: 29.7rem;
            height: 2.4rem;
            border-radius: 0.8rem;
            padding: 0 1.3rem;
          }
        }
        .from-input1 {
          input {
            width: 35.8rem;
            height: 2.4rem;
            border-radius: 0.8rem;
            padding: 0 1.3rem;
          }
        }
        .round {
          display: inline-block;
          width: 1.4rem;
          height: 1.4rem;
          border-radius: 0.5rem;
          background: #fff;
          vertical-align: middle;
          cursor: pointer;
          margin-right: 0.3rem;
        }
        .select-color {
          background: #000;
        }
      }
      .activity-right {
        float: left;
        // height: 50rem;
      }
      .activity-link {
        float: right;
        width: 4rem;
        height: 10rem;
        div {
          display: inline-block;
          text-align: center;
          &:nth-child(2) {
            margin-top: 2rem;
          }
          span {
            font-size: 1rem;
            text-align: center;
            cursor: pointer;
          }
          .iconfont {
            font-size: 2.8rem;
          }
          .title {
            width: 5rem;
            text-align: center;
          }
        }
      }
    }
    .activity-foot {
      padding: 2rem 0;
      .btn-box {
        margin-left: 40rem;
        .calcel {
          margin-left: 0.5rem;
        }
      }
    }
  }
}
#app .el-date-editor.el-input.change-date {
  position: absolute;
  top: 0;
  left: 0;
  height: 2.4rem;
  width: 18.8rem;
  opacity: 0;
  .el-input__inner {
    cursor: pointer;
  }
}
#app .el-date-editor.el-input.change-time {
  position: absolute;
  top: 0;
  height: 2.4rem;
  width: 10.2rem;
  left: 0;
  opacity: 0;
  .el-input__inner {
    cursor: pointer;
  }
}
.note {
  height: 10rem;
  margin-bottom: 1.5rem;
  .title {
    font-size: 1.4rem;
    display: inline-block;
    width: 7.6rem;
    text-align: center;
  }
  .note-content {
    height: 10rem;
    width: 34.9rem;
    border-radius: 0.8rem;
    background: #e8e8e8;
    line-height: 7.8rem;
    text-align: center;
    float: right;
    overflow: hidden;
    textarea {
      width: 100%;
      height: 100%;
      padding: 1rem;
      resize: none;
    }
  }
}
.img-data {
  float: left;
  width: 42.5rem;
  .operation-area {
    height: 7.6rem;
    .headline {
      font-size: 1.4rem;
      display: inline-block;
      width: 7.6rem;
      text-align: center;
    }
    .area {
      height: 7.8rem;
      width: 34.9rem;
      border-radius: 0.8rem;
      background: #e8e8e8;
      line-height: 7.8rem;
      text-align: center;
      float: right;
      cursor: pointer;
      .icon-upload {
        font-size: 2.5rem;
        color: #000;
        vertical-align: middle;
      }
      input {
        display: none;
      }
    }
  }
  .img-progress {
    width: 100%;
    padding-left: 7.6rem;
    margin-top: 0.8rem;
    height: 4.9rem;
    .look-img {
      width: 6.8rem;
      height: 4.9rem;
      border-radius: 0.5rem;
      overflow: hidden;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .look-progress {
      float: left;
      width: 26.6rem;
      margin-left: 1rem;
      font-size: 1.2rem;
      .img-name,
      .proportion {
        width: 100%;
        span:nth-child(1) {
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        span:nth-child(2) {
          float: right;
        }
      }
      .file-size {
        font-size: 12px;
        line-height: 1.4rem;
      }
      .icon-guanbi {
        font-size: 12px;
        line-height: 1.4rem;
        cursor: pointer;
      }
      .grogress {
        width: 100%;
        background: #596569;
        border-radius: 0.3rem;
        height: 0.6rem;
        overflow: hidden;
        position: relative;
        .grogress-success {
          display: inline-block;
          height: 100%;
          background: #fdca6c;
          // width: 50px;
          position: absolute;
        }
      }
      .proportion {
        font-size: 12px;
        line-height: 1.4rem;
      }
    }
  }
}

// nicky
.sms-body {
  // padding: 0rem 2rem;
  display: flex;
  font-size: vc;
  justify-content: center;
  width: 100%;
  height: 3rem;

  input {
    margin: 0rem 1rem 0rem 4rem;
    display: flex;
    flex: 5;
    text-align: center;
    font-size: 1rem;
  }

  button {
    position: relative;
    margin: 0rem 4rem 0rem 0rem;
    display: flex;
    flex: 1;
    background: #dfe6e9;

    img {
      position: absolute;
      background: #dfe6e9;
      top: 0;
    }

    .reciprocal {
      opacity: 0.2;
    }

    span {
      position: absolute;
      display: flex;
      margin: auto auto;
      justify-content: center;
      top: 25%;
      align-items: center;
      width: 100%;
      font-size: 1.3rem;
    }
  }
}

.note {
  font-size: 0.9rem;
  margin-top: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/addActivity.vue